import { render, staticRenderFns } from "./FooterDrawer.vue?vue&type=template&id=7b15c579"
import script from "./FooterDrawer.vue?vue&type=script&lang=ts"
export * from "./FooterDrawer.vue?vue&type=script&lang=ts"
import style0 from "./FooterDrawer.vue?vue&type=style&index=0&id=7b15c579&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports